import {connect} from 'react-redux'
import AuthGuard from './AuthGuard'
import {AppDispatch} from 'Store'
import {RootState} from 'Store/Reducers'
import {getUser} from 'Store/Actions/AuthActions'

const mapStateToProps = (state: RootState) => ({
  auth: state.auth,
})

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getUser: () => dispatch(getUser()),
})

export const AuthGuardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthGuard)
